import React, { useState, useEffect } from 'react';
import "./AboutCom.scss";

import AOS from 'aos';
import 'aos/dist/aos.css';

import { IoSchool, IoLocationSharp } from 'react-icons/io5';
import { FaBriefcase } from 'react-icons/fa';
import { MdWork } from 'react-icons/md';

const AboutCom = () => {

    useEffect(() => {
        AOS.init({
            duration: 1000, 
            debounceDelay: 50, 
            once: false, 
            mirror: true, 
        });
    }, []);

    const journeyData = [
        {
            type: 'experience',
            title: 'Napses Technologies',
            subtitle: 'Full Stack Developer',
            location: 'Bangalore, India',
            period: 'Feb 2026 - Present',
            details: [
                'Built Recombee-powered recommendations for a React Native reels platform, syncing 100K+ user interactions to improve feed and search across short videos and episodic content',
                'Developed event-driven NestJS workflows with Kafka and Redis — 80%+ reduction in interaction ingestion latency via async processing and scalable queue workers',
                'Built a React + Vite CMS for publisher teams to bulk upload videos, series, and episodes — 1,500+ content rows per batch with validation and CDN-backed media'
            ],
            techStack: 'NestJS, React, React Native, TypeScript, MySQL, Redis, Kafka, GCP',
            icon: <MdWork />,
            color: '#F8615C',
            status: 'current'
        },
        {
            type: 'experience',
            title: 'Hypergro AI',
            subtitle: 'Software Development Engineer',
            location: 'Bangalore, India',
            period: 'May 2025 - Feb 2026',
            details: [
                'Architected AI-driven email automation for Kotak Bank with Node.js, n8n, and async workflows — 90% reduction in campaign creation time',
                'Built a modular AI plugins marketplace with 6+ plugins and plan-based feature gating across 5+ model tiers',
                'Implemented referral system with collision-safe codes and transactional rewards — 25% signup increase, 100+ referrals/month',
                'Developed team collaboration APIs with RBAC, bulk async invites, and tokenized enterprise onboarding flows'
            ],
            techStack: 'React Remix, Node.js, MongoDB, TypeScript, GCP, n8n',
            icon: <FaBriefcase />,
            color: '#9b59b6',
            status: 'completed'
        },
        {
            type: 'experience',
            title: 'Virtualify Software Consultancy',
            subtitle: 'Software Developer',
            location: 'Remote',
            period: 'Aug 2024 - May 2025',
            details: [
                'Migrated Free Malaysia Today (500K+ DAU) to Next.js 15 with ISR, WebSub Hub, and real-time rendering — 60% faster page loads under peak traffic',
                'Optimized delivery using Cloudflare CDN and edge caching — 70% less origin load and 40% faster global content delivery',
                'Co-developed the FMT mobile app with React Native — 20K+ new installs across platforms'
            ],
            techStack: 'Next.js, React Native, GraphQL, Cloudflare, Node.js, Docker, WordPress',
            icon: <FaBriefcase />,
            color: '#f7cb45',
            status: 'completed'
        },
        {
            type: 'education',
            title: 'Madhav Institute of Technology and Science (MITS)',
            subtitle: 'B.Tech in Information Technology (AI + Robotics)',
            location: 'Gwalior, India',
            period: '2020 - 2024',
            details: 'CGPA: 8.21',
            icon: <IoSchool />,
            color: '#3f91f9',
            status: 'completed'
        }
    ];

    return (
        <section className="about_cls section_padding">
            <div className="container">
                <div className="row justify_content_cntr">
                    <div className="about_box" id="text" data-aos="fade-up">
                        <div className="section_title about-title">
                            <h2>My Journey</h2>
                            <h4>From Current to College</h4>
                            <div className="line" />
                        </div>

                        <div className="modern_timeline" data-aos="fade-up">
                            <div className="timeline_line"></div>
                            
                            {journeyData.map((item, index) => {
                                const isCurrent = item.status === 'current';
                                const isCompleted = item.status === 'completed';
                                const isEven = index % 2 === 0;
                                
                                return (
                                    <div 
                                        key={index} 
                                        className={`timeline_item ${isEven ? 'left' : 'right'} ${isCurrent ? 'current' : ''}`}
                                        data-aos={isEven ? 'fade-right' : 'fade-left'}
                                        data-aos-delay={index * 150}
                                    >
                                        <div className="timeline_marker" style={{ backgroundColor: item.color }}>
                                            <div className="marker_icon">{item.icon}</div>
                                            {isCurrent && <div className="current_pulse"></div>}
                                        </div>
                                        
                                        <div className="timeline_content">
                                            <div className="timeline_card" style={{ borderLeftColor: item.color }}>
                                                <div className="card_header">
                                                    <div className="header_top">
                                                        <h3>{item.title}</h3>
                                                        <span className="timeline_period" style={{ backgroundColor: `${item.color}15`, color: item.color }}>
                                                            {item.period}
                                                        </span>
                                                    </div>
                                                    <div className="card_subtitle">
                                                        <h4>{item.subtitle}</h4>
                                                        <div className="location_badge">
                                                            <IoLocationSharp />
                                                            <span>{item.location}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div className="card_body">
                                                    {item.type === 'education' ? (
                                                        <div className="education_details">
                                                            <p>{item.details}</p>
                                                        </div>
                                                    ) : (
                                                        <div className="experience_details">
                                                            <ul className="achievements_list">
                                                                {item.details.map((detail, idx) => (
                                                                    <li key={idx}>
                                                                        <span className="bullet" style={{ color: item.color }}>▸</span>
                                                                        {detail}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                            <div className="tech_stack" style={{ borderColor: `${item.color}30`, backgroundColor: `${item.color}10` }}>
                                                                <strong style={{ color: item.color }}>Tech Stack:</strong> 
                                                                <span>{item.techStack}</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutCom;
